import mapboxgl, { LngLatLike } from "mapbox-gl";
import { maptiler_key } from "../../auth/keys";

export const makeMap = (
    containerName = "map-root",
    zoom?: number,
    center?: LngLatLike
): mapboxgl.Map => {
    const startZoom = zoom ? zoom : 4;
    const startPos: LngLatLike = center ? center : [138.037196, 35.164281];

    // 初期位置は日本全体
    const map = new mapboxgl.Map({
        container: containerName,
        style: `https://api.maptiler.com/maps/streets/style.json?key=${maptiler_key}`,
        interactive: true,
        center: startPos,
        zoom: startZoom,
        bearing: 0,
        pitch: 0,
    });

    map.addControl(new mapboxgl.NavigationControl(), "bottom-right");

    map.on("load", () => {
        console.debug("Map loaded with container:", containerName);
    });

    return map;
};
